var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeFire01 = function SvgTypeFire01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "type_fire-01_svg2__a",
    x1: 28.01,
    x2: 171.99,
    y1: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M154.93 75.91c-.54-.68-1.19-.54-1.54-.41-.29.12-.94.49-.85 1.42.11 1.12.17 2.26.18 3.39.05 4.69-1.83 9.29-5.17 12.62-3.31 3.3-7.67 5.08-12.3 5.03-6.33-.08-11.59-3.38-15.19-9.55-2.98-5.1-1.67-11.68-.28-18.65.81-4.08 1.65-8.29 1.65-12.31 0-31.25-21.01-49.27-33.53-57.24a1.4 1.4 0 0 0-.72-.22c-.36 0-.64.15-.77.25-.27.18-.7.6-.56 1.33 4.79 25.41-9.49 40.7-24.6 56.88-15.58 16.68-33.23 35.59-33.23 69.69 0 39.62 32.23 71.85 71.85 71.85 32.62 0 61.38-22.74 69.94-55.31 5.84-22.2-.28-50.49-14.87-68.78Zm-53.28 108.75c-9.92.45-19.36-3.11-26.56-10-7.13-6.82-11.22-16.33-11.22-26.1 0-18.34 7.01-31.8 25.87-49.67.31-.29.62-.39.9-.39.25 0 .47.08.61.15.31.15.83.53.76 1.33-.67 7.85-.66 14.36.03 19.36 1.78 12.77 11.13 21.35 23.26 21.35 5.95 0 11.61-2.24 15.95-6.3.5-.47 1.07-.41 1.28-.37.29.06.67.24.87.72a35.8 35.8 0 0 1 2.73 13.71c.06 19.11-15.41 35.36-34.49 36.21Z",
    style: {
      fill: "url(#type_fire-01_svg2__a)"
    }
  }));
};
export default SvgTypeFire01;